import React, { useEffect, useState, useRef } from "react";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import { Fingerprint } from "lucide-react";
import Ekyc from "./EkycComponent1";
import TwoFactorAuth from "./TwoFactorAuth1";
import localBanksData from "../../../MasterJson/banks_aeps_2.json"
export default function AepsForm1({
  onSubmit,
  loading,
  previousData,
  processing,
  clearFormTrigger
}) {
  const userId = useSelector(
    (state) => state.auth?.employeeDetails?.userId
  );
  const username = useSelector(
    (state) => state.auth?.employeeDetails?.username
  );

  // --- INTEGRATED APIs ---
  const { callApi: checkEkycApi } = useApi(
    `/aeps/fingpay/ekyc-status/${username || ""}`,
    "GET"
  );

  const { callApi: check2FAApi } = useApi(
    `/aeps/fingpay/daily-2fa-status/${username || ""}`,
    "GET"
  );

  // Removed getbank API hook here

  const [banks, setBanks] = useState([]);

  const [form, setForm] = useState({
    aadhaar: "",
    mobile: "",
    amount: "",
    bank: "",
    txnType: "CW"
  });

  const [is2FAVerified, setIs2FAVerified] = useState(true);
  const [show2FA, setShow2FA] = useState(false);
  const [showDaily2FAAlert, setShowDaily2FAAlert] = useState(false);
  const [showOtherBanks, setShowOtherBanks] = useState(false);
  const [showEkycRequired, setShowEkycRequired] = useState(false);

  const bankMappings = [
    { short: "SBI", full: "State Bank of India" },
    { short: "PNB", full: "Punjab National Bank" },
    { short: "BOB", full: "BANK OF BARODA" },
    { short: "BOI", full: "BANK OF INDIA" },
    { short: "UBI", full: "UNION BANK OF INDIA" },
    { short: "INDIAN", full: "INDIAN BANK" },
    { short: "CBI", full: "CENTRAL BANK OF INDIA" },
    { short: "CANARA", full: "CANARA BANK" },
    { short: "BOM", full: "BANK OF MAHARASHTRA" },
    { short: "PSB", full: "PUNJAB AND SIND BANK" },
    { short: "IOB", full: "INDIAN OVERSEAS BANK" },
    { short: "UCO", full: "UCO BANK" },
    { short: "AIRTEL", full: "AIRTEL PAYMENTS BANK" },
    { short: "IPPB", full: "INDIA POST PAYMENTS BANK" },
    { short: "HDFC", full: "HDFC Bank" },
    { short: "ICICI", full: "ICICI Bank" },
    { short: "AXIS", full: "Axis Bank" },
    { short: "IDBI", full: "IDBI BANK" },
    { short: "INDUSIND", full: "IndusInd Bank" },
    { short: "KOTAK", full: "Kotak Mahindra Bank" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "bank") {
      const selectedBank = banks.find((b) => b.iin === value);
      setForm((prev) => ({
        ...prev,
        bank: selectedBank || ""
      }));
      return;
    }

    if (name === "aadhaar") {
      const onlyNum = value.replace(/\D/g, "");
      if (onlyNum.length <= 12) {
        setForm((prev) => ({
          ...prev,
          aadhaar: onlyNum
        }));
      }
      return;
    }

    if (name === "mobile") {
      const onlyNum = value.replace(/\D/g, "");
      if (onlyNum.length <= 10) {
        setForm((prev) => ({
          ...prev,
          mobile: onlyNum
        }));
      }
      return;
    }

    if (name === "amount") {
      const onlyNum = value.replace(/\D/g, "");
      setForm((prev) => ({
        ...prev,
        amount: onlyNum
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const isFormValid =
    form.aadhaar.length === 12 &&
    form.mobile.length === 10 &&
    form.bank &&
    (form.txnType !== "CW" ? true : form.amount.trim() !== "");

  // const handleQuickBankSelect = (bankObj) => {
  //   setForm((prev) => ({
  //     ...prev,
  //     bank: bankObj
  //   }));
  // };
  // ✅ UPDATED: Hides dropdown when a top button is clicked
  const handleQuickBankSelect = (bankObj) => {
    setForm((prev) => ({
      ...prev,
      bank: bankObj
    }));
    setShowOtherBanks(false);
  };

  // const handlePreviousData = () => {
  //   if (!previousData) return;
  //   setForm((prev) => ({
  //     ...prev,
  //     ...previousData,
  //     bank: previousData?.bank || ""
  //   }));
  // };
  // ✅ UPDATED: Pre-fill search term if returning to previous data
  const handlePreviousData = () => {
    if (!previousData) return;
    setForm((prev) => ({
      ...prev,
      ...previousData,
      bank: previousData?.bank || ""
    }));
    
    if (previousData?.bank) {
        setSearchTerm(previousData.bank.name || "");
    }
  };

  // ✅ NEW: Selects bank from dropdown AND keeps dropdown visible
  const handleDropdownSelect = (bankObj) => {
    setForm((prev) => ({
      ...prev,
      bank: bankObj
    }));
    setSearchTerm(bankObj.name); // Keep selected name in search input
    setIsDropdownOpen(false); // Close the popup list
  };


  // --- STATUS CHECK LOGIC ---
  const checkStatus = async () => {
    if (!userId) return;

    try {
      // 1. Check E-KYC Status First
      const ekycResponse = await checkEkycApi(null);
      
      const isEkycDone = ekycResponse?.ekycDone === true;

      if (!isEkycDone) {
        setShowEkycRequired(true);
        setShowDaily2FAAlert(false);
        setIs2FAVerified(false);
        return; 
      } else {
        setShowEkycRequired(false);
      }

      // 2. Check Daily 2FA Status
      const twoFaResponse = await check2FAApi(null);
      
      const is2FaDone = twoFaResponse?.authenticated === true;

      if (!is2FaDone) {
        setIs2FAVerified(false);
        setShow2FA(true);
        setShowDaily2FAAlert(true);
      } else {
        setIs2FAVerified(true);
        setShow2FA(false);
        setShowDaily2FAAlert(false);
      }

    } catch (error) {
      console.error("Status Check Error", error);
      setShowEkycRequired(true);
      setIs2FAVerified(false);
    }
  };

  // --- FETCH BANKS VIA LOCAL JSON ---
  const getbanks = async () => {
    try {
     if (localBanksData?.statuscode === "TXN") {
      setBanks(localBanksData?.data || []);
    }
    } catch (error) {
      console.error("Failed to load local bank data", error);
    }
  };


  // const [showEkycRequired, setShowEkycRequired] = useState(false);

  // ✅ 1. ADD THESE NEW STATES HERE
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);


  const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    if (isFormValid && !loading && !processing && is2FAVerified && !showEkycRequired) {
      onSubmit(form);
    }
  }
};

  // ✅ 2. ADD THIS EFFECT HERE
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    checkStatus();
  }, [userId]);

  // Run the local fetch only once when the component mounts
  useEffect(() => {
    getbanks();
  }, []);

  useEffect(() => {
    if (clearFormTrigger) {
      setForm((prev) => ({
        ...prev,
        bank: "",
        aadhaar: "",
        mobile: "",
        amount: ""
      }));
      setSearchTerm("");
    }
  }, [clearFormTrigger]);

  if (form.txnType === "2FA") {
    return (
      <TwoFactorAuth
        onBack={() => setForm({ ...form, txnType: "CW" })}
        onSuccess={() => {
          checkStatus();
          setForm((prev) => ({ ...prev, txnType: "CW" }));
        }}
      />
    );
  }

  // const highlightedBanks = bankMappings
  //   .map((item) => ({
  //     label: item.short,
  //     bank: banks.find(
  //       (b) => b.name?.toLowerCase() === item.full.toLowerCase()
  //     )
  //   }))
  //   .filter((x) => x.bank);

  // const otherBanks = banks.filter(
  //   (b) =>
  //     !bankMappings.some(
  //       (item) => item.full.toLowerCase() === b.name?.toLowerCase()
  //     )
  // );

  const highlightedBanks = bankMappings
    .map((item) => ({
      label: item.short,
      bank: banks.find(
        (b) => b.name?.toLowerCase() === item.full.toLowerCase()
      )
    }))
    .filter((x) => x.bank);

  // ✅ REPLACE `otherBanks` WITH THIS:
  const safeSearchTerm = (searchTerm || "").toLowerCase();
  const filteredDropdownBanks = banks.filter((b) => 
    b.name && b.name.toLowerCase().includes(safeSearchTerm)
  );

  return (
    <div className="bg-[#f4f6fb]">
      <div className="ml-[12vw] -mt-14 font-semibold text-lg py-2">
      AEPS 4
    </div>
    {/* <div className="overflow-hidden bg-[#f4f6fb]"> */}
      {showEkycRequired ? (
        <div className="bg-orange-50 border border-orange-300 rounded-lg text-center p-3 mb-2">
          <p className="text-orange-700 font-semibold text-base">
            Please check your e-KYC status. If not initiated, complete e-KYC first.
            After bank approval, you can perform AEPS transactions.
          </p>
        </div>
      ) : (
        showDaily2FAAlert && (
          <div className="mb-2 bg-blue-50 border p-2 rounded-lg text-center text-blue-700 text-base font-medium">
            Daily 2FA required before AEPS transactions
          </div>
        )
      )}

      {form.txnType === "EKYC" ? (
        <Ekyc 
          onBack={() => setForm({ ...form, txnType: "CW" })} 
          onSuccess={() => {
            checkStatus();
            setForm((prev) => ({ ...prev, txnType: "CW" }));
          }}
        />
      ) : (
        <div className="">
        {/* <div className="overflow-hidden"> */}
          <div className="grid grid-cols-12 h-full">
            {/* LEFT */}
            <div className="col-span-5 border-r px-5 py-4 flex flex-col justify-start h-full" onKeyDown={handleKeyDown}>
              <h3 className="font-bold text-xl mb-4">Transaction Type :</h3>

              <div className="grid grid-cols-2 gap-y-3 text-base font-semibold mb-6">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.txnType === "CW"}
                    onChange={() => setForm({ ...form, txnType: "CW" })}
                  />
                  Cash Withdrawal
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.txnType === "BE"}
                    onChange={() => setForm({ ...form, txnType: "BE" })}
                  />
                  Balance Enquiry
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.txnType === "MS"}
                    onChange={() => setForm({ ...form, txnType: "MS" })}
                  />
                  Mini Statement
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.txnType === "EKYC"}
                    onChange={() => setForm({ ...form, txnType: "EKYC" })}
                  />
                  E-KYC
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.txnType === "2FA"}
                    onChange={() => setForm({ ...form, txnType: "2FA" })}
                  />
                  2-Factor Auth
                </label>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block mb-2 text-base font-semibold">
                    Aadhaar Number
                  </label>
                  <input
                    name="aadhaar"
                    value={form.aadhaar}
                    onChange={handleChange}
                    maxLength={12}
                    inputMode="numeric"
                    placeholder="Aadhaar Number"
                    className="w-full h-12 border-2 rounded-lg px-4 text-base font-bold"
                  />
                  {form.aadhaar && form.aadhaar.length < 12 && (
                    <p className="text-red-500 text-sm mt-1">
                      Aadhaar must be 12 digits
                    </p>
                  )}
                </div>

                <div>
                  <label className="block mb-2 text-base font-semibold">
                    Mobile Number
                  </label>
                  <input
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    maxLength={10}
                    inputMode="numeric"
                    placeholder="Mobile Number"
                    className="w-full h-12 border-2 rounded-lg px-4 text-base font-bold"
                  />
                  {form.mobile && form.mobile.length < 10 && (
                    <p className="text-red-500 text-sm mt-1">
                      Mobile must be 10 digits
                    </p>
                  )}
                </div>

                {form.txnType === "CW" && (
                  <div>
                    <label className="block mb-2 text-base font-semibold">
                      Transaction Amount
                    </label>
                    <input
                      name="amount"
                      value={form.amount}
                      onChange={handleChange}
                      inputMode="numeric"
                      placeholder="Transaction Amount"
                      className="w-full h-12 border-2 rounded-lg px-4 text-base"
                    />
                  </div>
                )}
              </div>

              <div className="mt-5">
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => onSubmit(form)}
                    disabled={
                      loading ||
                      processing ||
                      !isFormValid ||
                      !is2FAVerified ||
                      showEkycRequired
                    }
                    className="h-12 bg-green-600 hover:bg-green-700 text-white rounded-lg text-base font-bold flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    <Fingerprint size={20} />
                    {loading ? "Capturing..." : "Capture"}
                  </button>
                  <button
                    type="button"
                    onClick={handlePreviousData}
                    disabled={!previousData}
                    className="h-12 bg-slate-700 text-white rounded-lg text-base font-bold"
                  >
                    Previous
                  </button>
                </div>

                {!is2FAVerified && (
                  <p className="text-red-500 text-sm mt-3">
                    Please complete daily 2FA first
                  </p>
                )}
              </div>
            </div>

            {/* RIGHT BANKS */}
            <div className="col-span-7 px-4 py-4 ">
            {/* <div className="col-span-7 px-4 py-4 overflow-hidden"> */}
              <h3 className="font-bold text-xl mb-4">Bank Name :</h3>

              <div className="grid grid-cols-5 gap-3">
                {highlightedBanks.map(({ label, bank }, index) => {
                  const colors = [
                    "bg-blue-700", "bg-red-600", "bg-orange-600", "bg-indigo-900",
                    "bg-rose-600", "bg-blue-800", "bg-blue-600", "bg-teal-600",
                    "bg-sky-600", "bg-orange-500", "bg-indigo-700", "bg-green-600",
                    "bg-purple-600", "bg-cyan-600", "bg-red-500", "bg-orange-700",
                    "bg-pink-600", "bg-violet-600", "bg-emerald-600", "bg-fuchsia-600"
                  ];

                  return (
                    <button
                      key={bank.iin}
                      type="button"
                      onClick={() => handleQuickBankSelect(bank)}
                      className={`
                        h-16 rounded-xl text-white font-bold text-sm shadow leading-tight
                        ${colors[index]}
                        ${form.bank?.iin === bank.iin ? "ring-4 ring-green-300" : ""}
                      `}
                    >
                      <div className="text-[16px]">{label}</div>
                      <div className="text-[12px] mt-1 opacity-90">
                        {bank.name}
                      </div>
                    </button>
                  );
                })}

                {/* <button
                  onClick={() => setShowOtherBanks(!showOtherBanks)}
                  className="h-16 rounded-xl bg-blue-900 text-white font-bold text-sm shadow"
                >
                  OTHER BANKS
                </button> */}
                <button
                  onClick={() => {
                    setShowOtherBanks(!showOtherBanks);
                    if (!showOtherBanks && form.bank) {
                        setSearchTerm(form.bank.name); // Pre-fill if already selected
                    }
                  }}
                  className="h-16 rounded-xl bg-blue-900 text-white font-bold text-sm shadow"
                >
                  OTHER BANKS
                </button>
              </div>
{/* 
              {showOtherBanks && (
                <div className="mt-4">
                  <select
                    name="bank"
                    value={form.bank?.iin || ""}
                    onChange={handleChange}
                    className="w-full h-12 border-2 rounded-lg px-4 text-base"
                  >
                    <option>Select Other Bank</option>
                    {otherBanks.map((b) => (
                      <option key={b.iin} value={b.iin}>
                        {b.name}
                      </option>
                    ))}
                  </select>
                </div>
              )} */}
              {/* ✅ NEW CUSTOM SEARCHABLE DROPDOWN */}
              {showOtherBanks && (
                <div className="mt-4 relative" ref={dropdownRef}>
                  <input
                    type="text"
                    placeholder="Search and select bank..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setIsDropdownOpen(true);
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                    className="w-full h-12 border-2 rounded-lg px-4 text-base focus:border-indigo-600 focus:outline-none bg-white"
                  />
                  
                  {isDropdownOpen && (
                    <div className="absolute z-50 w-full mt-1 bg-white border border-slate-300 rounded-lg shadow-2xl max-h-60 overflow-y-auto">
                      {filteredDropdownBanks.length > 0 ? (
                        filteredDropdownBanks.map((b) => (
                          <div
                            key={b.iin}
                            onClick={() => handleDropdownSelect(b)}
                            className="px-4 py-3 hover:bg-slate-100 cursor-pointer text-slate-700 border-b last:border-b-0 text-sm font-medium"
                          >
                            {b.name}
                          </div>
                        ))
                      ) : (
                        <div className="px-4 py-3 text-slate-500 text-sm">No banks found</div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
